import React from 'react';
import './DetailPageLoader.css';

export default function DetailPageLoader({ entityLabel }) {
	return (
		<div className='dpl-page'>
			<div className='dpl-bar'>
				<i className='dpl-bar-fill' />
			</div>

			<div className='dpl-mark' />

			{entityLabel && (
				<div className='dpl-label'>
					Cargando <span className='dpl-label-entity'>{entityLabel}</span>…
				</div>
			)}
		</div>
	);
}
